var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnverifiedResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.171 44.213c1.71 38.88-77.91 95.837-113.573 68.72-35.663-27.118-33.742-69.85-14.687-82.131 19.055-12.282 42.143 12.035 65.045-2.633 22.902-14.667 61.506-22.837 63.215 16.044z",
    fill: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 100c4.4 0 8-3.6 8-8V28c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h37z",
    fill: "#EDEDF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 28v64c0 3.3-2.7 6-6 6H72c-3.3 0-6-2.7-6-6V28c0-3.3 2.7-6 6-6h36.9c3.4 0 6.1 2.7 6.1 6z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C0C2CC",
    fillRule: "nonzero",
    cx: 90.5,
    cy: 89.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2 28.5h6.7c.6 0 1-.4 1-1s-.4-1-1-1h-6.7c-.6 0-1 .4-1 1s.4 1 1 1z",
    fill: "#C0C2CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 63a1 1 0 01.993.883l.007.117v6a1 1 0 01-.883.993L100.5 71h-6a1 1 0 01-.117-1.993L94.5 69h5v-5a1 1 0 01.883-.993L100.5 63zm-20 0a1 1 0 01.993.883L81.5 64v5h5a1 1 0 01.993.883L87.5 70a1 1 0 01-.883.993L86.5 71h-6a1 1 0 01-.993-.883L79.5 70v-6a1 1 0 011-1zm6-14a1 1 0 01.117 1.993L86.5 51h-5v5a1 1 0 01-.883.993L80.5 57a1 1 0 01-.993-.883L79.5 56v-6a1 1 0 01.883-.993L80.5 49h6zm14 0a1 1 0 01.993.883l.007.117v6a1 1 0 01-1.993.117L99.5 56v-5h-5a1 1 0 01-.993-.883L93.5 50a1 1 0 01.883-.993L94.5 49h6z",
    fill: "#9FA2AF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAE33",
    cx: 127,
    cy: 49,
    r: 12.833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.366 43.905a1.458 1.458 0 012.205 1.903l-.104.12-8.653 8.99a1.459 1.459 0 01-1.982.112l-.12-.111-3.596-3.737a1.458 1.458 0 011.985-2.13l.116.108 2.545 2.644 7.604-7.899z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedResult);
export default __webpack_public_path__ + "static/media/unverified-result.b09e5b38.svg";
export { ForwardRef as ReactComponent };